import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import kitcut from "../../../utils/kitcut";
import './winners-slider.scss'
// Import Swiper styles
// import required modules
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/bundle';
import { getPoints } from "../../../utils/getPoints";

export const WinnersSlider = ({ className, winners = [], showWinners = false, getWinnersPopup = () => { } }) => {
  const dispatch = useDispatch()
  const isMobile = useSelector(state => state.app.isMobile);
  const langName = useSelector(state => state.app.currentLangName)
  const [bodyWidth, setBodyWidth] = useState(0);

  useEffect(() => {
    setBodyWidth(window.innerWidth);
    const handleResize = (event) => {
      setBodyWidth(event.target.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const fn = (number) => {
    if (parseInt(number) < 10) {
      return '0' + number;
    }
    return number;
  }
  let heightVar;
  if (bodyWidth >= 991) {
    heightVar = 16
    if (className === 'shop') heightVar *= 1.35;
  } else if (bodyWidth >= 768 && bodyWidth < 991) {
    heightVar = 12
  } else if (bodyWidth < 768) {
    heightVar = 14
  }
  let heightRow = 0;
  if (isMobile) {
    heightRow = bodyWidth * ((heightVar / 100));
  } else {
    heightRow = (640 / 2) * ((heightVar / 100));
  }
  if (!showWinners) return;
  return (
    <div className='winners' onClick={() => { if (showWinners) dispatch(getWinnersPopup()) }}>
      <Swiper
        direction={'vertical'}
        modules={[Autoplay]}
        style={{ "height": (heightRow * 3) + "px", "cursor": (showWinners ? "pointer" : 'default') }}
        spaceBetween={0}
        slidesPerView={3}
        loop={true}
        centeredSlides={true}
        autoplay={true}
        allowTouchMove={false}
        className="swiper-game"
      >
        {
          winners.map(function (item, index) {
            let a = item.createdAt.split(' ')[0].split('-')
            let b = item.createdAt.split(' ')[1].split(':')
            let date = new Date(Date.UTC(a[0], parseInt(a[1]) - 1, a[2], b[0], b[1], b[2]))

            let formateDate = [fn(date.getDate()) + '.' + fn((date.getMonth() + 1)) + '.' + date.getFullYear(),
            fn(date.getHours()) + ':' + fn(date.getMinutes()) + ':' + fn(date.getSeconds())]
            if (typeof item.id === 'undefined') return (null)
            let pointName = '';
            if (item.type === 'points') {
              pointName = getPoints(langName, item.points);
            }
            return (
              <SwiperSlide key={index} >
                {({ isActive }) => (
                  <div className="winners__line">
                    <div className="winners__row_outer">
                      <div className="winners__row">
                        <div className="winners__left">
                          <div className="winners__circle" style={{ "height": (isActive ? (heightRow * 0.7) : (heightRow * 0.55)) + "px", "width": (isActive ? (heightRow * 0.7) : (heightRow * 0.55)) + "px" }}>
                            {(item.type === 'gift' && item.image)
                              ? <img className="winners__img" alt="gift" src={item.image} />
                              : <div className="winners__points">{'+' + item.points}</div>
                            }
                          </div>
                        </div>
                        <div className="winners__center">
                          <div className="winners__subscriber">{kitcut(item.subscriber, 20)}</div>
                          <div className="winners__name">
                            {item.type === 'points'
                              ? kitcut('+' + item.points + " " + pointName, 20)
                              : kitcut(item.name, 20)}
                          </div>
                        </div>
                        <div className="winners__right">
                          <div className="winners__date">
                            <span>
                              {formateDate[0]}
                            </span>
                            <span>
                              {formateDate[1]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </SwiperSlide>
            )

          })
        }
      </Swiper>
      <div className="winners__gradient_top"></div>
      <div className="winners__gradient_bottom"></div>
    </div>

  )
}